import { Controller } from "@hotwired/stimulus"

// Cumulatively reveals form sections based on the selected sedation level.
// Each section carries a `data-min-rank`; a section is shown when the selected
// level's rank is >= that min rank. An optional `data-max-rank` also hides the
// section once the selected rank exceeds it (e.g. "No sedation" only shows for
// None and Nitrous). A blank selection (rank -1) hides everything. Visibility is
// toggled on the whole <section>, independent of the accordion controller that
// lives inside each one.
//
// Each form defines its own sedation levels (some states use values like
// `general`, `level2`, `class2`, `class3`), so we derive value→rank from the
// select's own options in order rather than hardcoding any one form's levels.
// The non-blank options are listed in ascending rank order, matching the
// 0-based `data-min-rank` the sections carry.

export default class extends Controller {
  static targets = ["select", "section"]

  connect() {
    this.update()
  }

  // Maps the currently selected option value to its rank using option order.
  // Returns -1 for a blank/unknown selection.
  selectedRank() {
    if (!this.hasSelectTarget) return -1
    const value = this.selectTarget.value
    if (value === "") return -1

    let rank = -1
    let i = 0
    for (const option of this.selectTarget.options) {
      if (option.value === "") continue
      if (option.value === value) {
        rank = i
        break
      }
      i += 1
    }
    return rank
  }

  update() {
    const selectedRank = this.selectedRank()

    this.sectionTargets.forEach((section) => {
      const minRank = parseInt(section.dataset.minRank, 10)
      const maxRank = section.dataset.maxRank === "" ? Infinity : parseInt(section.dataset.maxRank, 10)
      const hidden = selectedRank < minRank || selectedRank > maxRank
      section.classList.toggle("hidden", hidden)
    })
  }
}
